import React, { useEffect, useRef } from "react";

declare global {
  interface Window {
    ymaps: any;
  }
}

interface YandexMapProps {
  center?: [number, number];
  zoom?: number;
}

const API_KEY = process.env.VITE_YANDEX_MAPS_API_KEY;

const YandexMap: React.FC<YandexMapProps> = ({
  center = [40.260389, 44.329593], // Moscow coordinates as default
  zoom = 15,
}) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<any>(null);

  useEffect(() => {
    // Load Yandex Maps API
    const script = document.createElement("script");
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${API_KEY}&lang=en_US`;
    script.async = true;

    script.onload = () => {
      if (window.ymaps && mapRef.current) {
        window.ymaps.ready(() => {
          mapInstanceRef.current = new window.ymaps.Map(mapRef.current, {
            center: center,
            zoom: zoom,
            controls: ["zoomControl", "fullscreenControl"],
          });

          // Add restaurant marker
          const placemark = new window.ymaps.Placemark(
            center,
            {
              balloonContent: "Delicious Restaurant",
            },
            {
              preset: "islands#redDotIcon",
            }
          );

          mapInstanceRef.current.geoObjects.add(placemark);
        });
      }
    };

    document.head.appendChild(script);

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.destroy();
      }
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [center, zoom]);

  return (
    <div
      ref={mapRef}
      style={{
        width: "100%",
        height: "100%",
        minHeight: "400px",
      }}
    />
  );
};

export default YandexMap;
